import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { LocaleHtmlLang } from './components/LocaleHtmlLang';
import { ThemeProvider } from './theme/ThemeContext';
import './i18n';
import './styles/global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <LocaleHtmlLang />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
